import { toast } from 'react-toastify';
import { CourseFinancialAmongBranchesType } from '../../../../../api/types/reports/finanace/course-financial-among-branches.type';
import { CourseFinancialBranchBreakdownFilterDatamodel } from '../side-bar-filter/course-financial-branch-breakdown-filter';
import appApi from '../../../../../api/app-api';
import { FinancialData } from '../course-financial-branch-breakdown';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const getCourseFinancialBranchBreakdown = async (
  filters: CourseFinancialBranchBreakdownFilterDatamodel,
  setLoading: (loading: boolean) => void,
  setData: (data: FinancialData[]) => void,
) => {
  try {
    setLoading(true);
    if (!filters.branchId || !filters.courseId) {
      toast.warn('תחילה יש לבחור שלוחה וקורס');
      return;
    }
    const res = await appApi.getCourseFinancialInBranch(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
